import styled from 'styled-components';

export const HeaderBase = styled.header`
  position: relative;
`;
